import { render, staticRenderFns } from "./exhibitorList.vue?vue&type=template&id=28f02714&scoped=true&"
import script from "./exhibitorList.vue?vue&type=script&lang=js&"
export * from "./exhibitorList.vue?vue&type=script&lang=js&"
import style0 from "./exhibitorList.vue?vue&type=style&index=0&id=28f02714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f02714",
  null
  
)

export default component.exports